<template>
  <div>
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <main>
      <div class="userdata_edit container">
        <form @submit.prevent="submit">
          <div class="limit_num">
            <i>{{rawPhone.length}}</i>/9
          </div>
          <div class="text_box">
            <input class="country_code" type="tel" maxlength="4" value="+886" disabled />
            <input class="number" type="tel" placeholder="912345678" v-model="rawPhone" :disabled="status === 'sent'" />
            <button type="button">
              <i class="icon-delete" v-on:click="cleanPhone()"></i>
            </button>
          </div>
          <!-- <div class="error" v-if="!$v.rawPhone.required">請輸入電話號碼</div> -->
          <div class="error" v-if="!$v.rawPhone.alpha">輸入正確電話號碼以傳送簡訊</div>

          <button
            v-if="status === 'send'"
            type="button"
            :class='[$v.rawPhone.$invalid || (originalPhone && (phone === originalPhone)) ? "sent": "send"]'
            :disabled="$v.rawPhone.$invalid || (originalPhone && (phone === originalPhone)) ? true : false"
            v-on:click="sendVerifySms();"
          >發送簡訊認證</button>
          <button v-if="status === 'sent'" type="button" class="sent">{{countDown}} 秒後可重新發送</button>
          <!-- <button type="button" class="send">重新發送簡訊</button> -->

          <div class="verify" v-if="sentOnce">
            <p class="attetion">
              發送簡訊需要一點時間，請您稍等片刻
              <br />
              若超過{{countDownSeconds}}秒尚未收到簡訊，請再重新發送一次
            </p>
            <div class="limit_num">
              <i>{{code.length}}</i>/4
            </div>
            <div class="text_box">
              <input class="verify_code" type="tel" maxlength="5" value="手機驗證碼" disabled />
              <input class="number" type="tel" maxlength="4" v-model="code" />
              <button type="button">
                <i class="icon-delete" v-on:click="code=''"></i>
              </button>
            </div>
            <div class="error" v-if="!$v.code.required">請輸入驗證碼</div>
            <div class="error" v-if="!$v.code.numeric">僅可輸入數字</div>
            <div class="error" v-if="verifyFailed">驗證碼錯誤，請重新輸入</div>
            <button type="submit" class="save" :disabled="$v.code.$invalid">儲存</button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";
import { Base64 } from "js-base64";
import apis from "@/services/apis";

import { required, minLength, helpers, numeric, sameAs, not } from "vuelidate/lib/validators";

const countDownSeconds = 30;
export default {
  name: "userData",
  data() {
    return {
      sentOnce: false,
      countryCode: '+886',
      rawPhone: "",
      phone: "",
      originalPhone: "",
      countDown: countDownSeconds,
      countDownSeconds: countDownSeconds,
      code: "",
      requestId: "",
      status: "send",
      verifyFailed: false
    };
  },
  validations: {
    rawPhone: {
      required,
      // alpha: helpers.regex('alpha', /^0([1-8]{1}[0-9]{7,8}|9[0-9]{8})$/) // 台灣電話 (不一定是手機)（開頭0)
      alpha: helpers.regex('alpha', /^(0{1})?([1-8]{1}[0-9]{7,8}|9[0-9]{8})$/) // 台灣電話（不一定是手機）(開頭可給可不給)
    },
    code: {
      required,
      minLength: minLength(4),
      numeric
    }
  },
  components: {
    SettingsHeader,
    Header
  },
  computed: {
    userId() {
      return localStorage.getItem("lineUserId");
    },
    uuid() {
      let uuid = localStorage.getItem("qcsso:uuid");
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      return uuid;
      // return localStorage.getItem("lineUserId");
    },
    userProfile() {
      return JSON.parse(Base64.decode(localStorage.getItem("lineUserProfile")));
    }
  },
  methods: {
    cleanPhone() {
      // 驗證中不給改？
      if(this.status === 'send') 
        this.phone='';
    },
    sendVerifySms() {
      this.status = "sent";
      this.sentOnce = true;

      this.phone = this.countryCode + this.rawPhone;
      
      let verifyApi = apis.sendUserPhoneVerifySms;
      let uid = this.userId;
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        verifyApi = apis.sendSsoUserPhoneVerifySms;
        uid = this.uuid;
      }
      // return apis.sendUserPhoneVerifySms(
      return verifyApi(
        uid, {
          phone: this.phone
        })
        .then(response => {
          this.requestId = response.requestId;
          this.countDownTimer();
        })
        .catch(e => {
          this.status = "send";
        });
    },
    submit() {
      let queryApi = apis.checkUserPhone;
      let uid = this.userId;

      if (GLOBAL_ENV_SDKTYPE === "sso") {
        queryApi = apis.checkSsoUserPhone;
        uid = this.uuid;
      }
      // return apis.checkUserPhone(
      return queryApi(
        uid, {
          code: this.code,
          requestId: this.requestId
        })
        .then(response => {
          this.$router.push({
            path: this.$router.currentRoute.meta.backTo,
            query: this.$router.currentRoute.query
          });
        })
        .catch(e => {
          console.log("verify failed " + e.stack);
          this.verifyFailed = true;
        });
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.status = "send";
        this.countDown = countDownSeconds;
      }
    }
  },
  mounted() {
    this.name = this.userProfile.name;

    this.phone = (this.userProfile.localPhone || this.userProfile.phone || '');
    
    if (this.phone) {
      console.log('handle code and phone ' + this.phone);
      if (this.phone.startsWith('0')) {
        this.rawPhone = this.phone.substring(1, this.phone.length);
      } else {
        let ss = this.phone.split('886');
        console.log('debug ss ' + JSON.stringify(ss));
        if (ss && ss.length == 2)
          this.rawPhone = ss[1];
      }
      console.log('code ' + this.countryCode);
      console.log('phone ' + this.rawPhone);
    }
    this.originalPhone = this.rawPhone;
    
    // this.originalPhone = this.phone = (this.userProfile.localPhone || this.userProfile.phone || '');
    
    console.log('the user profile gogo ' + JSON.stringify(this.userProfile));
  }
};
</script>

<style scoped>
.userdata_edit .verify {
  display: block;
}
/*.error {
  color: #ff0000;
  font-size: 14px;
  padding-bottom: 10px;
}*/
/* @import '../assets/css/theme_default.css'; */
</style>
